import React, { Fragment, useEffect } from 'react';

import { ALL, CUSTOM_SCOPES, FILTER_KEYS, GAMES, PRACTICES } from '../../../config/constants';
import { useRouter } from '../../../helpers/customHooks';
import { useFiltersDispatch, useFiltersState } from '../../../store/hooks';

export default () => {

  const { pathname } = useRouter();
  const { [FILTER_KEYS.EVENTS]: checkBoxEvents = ALL } = useFiltersState(CUSTOM_SCOPES.SCHEDULE, FILTER_KEYS.EVENTS);
  const { changeFilterData } = useFiltersDispatch();
  useEffect(changeFilterData(checkBoxEvents, FILTER_KEYS.EVENTS, CUSTOM_SCOPES.SCHEDULE), [pathname]);

  const labels = [ALL, PRACTICES, GAMES];
  const checks = labels.map((label, index) => {
    return (
      <Fragment key={label + index}>
        <input
          id={`radio-button-${label}`}
          type="radio"
          checked={checkBoxEvents === label}
          onChange={changeFilterData(label, FILTER_KEYS.EVENTS, CUSTOM_SCOPES.SCHEDULE)}
        />
        <label
          htmlFor={`radio-button-${label}`}
          className={'radio-label capitalize-text' + (checkBoxEvents === label ? ' label-bold' : '')}
        >
          {label}
        </label>
      </Fragment>
    );
  });
  
  return <div className="check-01 radio header-cc">{checks}</div>;
};
